import type { TourStep } from '../types';

export const traineeLoggingSteps: TourStep[] = [
  {
    target: '[data-tour="trainee-header"]',
    title: 'Your Experience Log',
    content:
      'As a trainee, you need to track supervised experience hours. This log keeps a running record your supervisor can review and approve.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="trainee-new-entry"]',
    title: 'Log a New Entry',
    content:
      'Click here to add an entry. Record the date, hours worked, activity type (inspection, report writing, analysis), property address, and any notes. Try adding one.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ll add one later',
  },
  {
    target: '[data-tour="trainee-progress"]',
    title: 'Track Your Progress',
    content:
      'See your total logged hours, how many entries are pending approval, and how many your supervisor has already approved.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="trainee-table"]',
    title: 'Your Entry Log',
    content:
      'All entries listed chronologically — date, activity type, hours, status (Pending, Approved, Revision Requested), and notes. Click any entry to edit it.',
    placement: 'top',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="trainee-export"]',
    title: 'Export for the State Board',
    content:
      'When it\'s time to submit your experience record, export the complete log with all entries, hour totals, and supervisor approvals.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
  },
];
